import Vue from "vue";
let currentRequest = 0;

const EmailMessageService = {
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START EMAIL_MESSAGE `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "email_messages",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] EMAIL_MESSAGE DISCARDED`);
        return null;
      }
      console.log(`[${request}] END EMAIL_MESSAGE `, searchFilterPagination.search);
      return res;
    } catch (error) {
      return { error: error };
    }
  }
};

export { EmailMessageService };
